import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import NavBar from 'js/components/NavBar';
import Footer from 'cccisd-footer';
import style from './style.css';
export default class NewLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,

        /**
         * Build Initial data
         *
         */
        buildClientData: PropTypes.func,

        /**
         * active clients
         */
        clients: PropTypes.array,

        /**
         * current client
         */
        currentClient: PropTypes.object,

        /**
         * loading state
         */
        loading: PropTypes.bool,

        /**
         * change client in redux
         */
        changeClient: PropTypes.func,
    };

    render() {
        return (
            <div className={style.body}>
                <div className={style.content}>
                    <NavBar className="container-fluid" />
                    <div>{this.props.children}</div>
                </div>
                <div className={style.footer}>
                    <Footer className="container-fluid" />
                </div>
            </div>
        );
    }
}
